export default __webpack_public_path__ + "static/media/lbc.72513205.svg";